import React, { FunctionComponent } from 'react'
import cn from 'classnames'
import Plural from 'plural-ru'
import { Popup } from '@/components/Popup'
import { MktuClassWord } from '@/services/Api/generated'

import { Word } from '@/domains/Account/modules/Mktu/components'
import styles from './ListSelectedWordsPopup.module.scss'
import { Icon } from '@/icons'

interface ListSelectedWordsPopupProps {
  className?: string
  words?: MktuClassWord[]
  onDelete: (word: MktuClassWord) => void
  onClose: () => void
  onBack: () => void
}
export const ListSelectedWordsPopup: FunctionComponent<
  ListSelectedWordsPopupProps
> = ({ className, words, onDelete, onClose, onBack }) => {
  return (
    <Popup className={cn(className, styles.popup)} onClose={onClose}>
      <div className={styles.popupContainer}>
        <button type="button" onClick={onBack} className={styles.back}>
          <Icon name="back" className={styles.iconBack} /> Назад
        </button>
        <div className={styles.title}>
          {Plural(
            words.length,
            'Выбран %d термин',
            'Выбрано %d термина',
            'Выбрано %d терминов'
          )}
        </div>
        <button onClick={onClose} className={styles.closeButton}>
          <Icon name="close" className={styles.closeButtonIcon} />
        </button>
        <div className={styles.content}>
          <div className={styles.list}>
            {words.map((word) => (
              <Word
                className={styles.word}
                key={word.uuid}
                id={word}
                name={word.word}
                onClick={onDelete}
                isNice={word.isNice}
                isDeletable
                isSelected
              />
            ))}
          </div>
        </div>
      </div>
    </Popup>
  )
}
